/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/devicesMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Devices. */
export class Devices {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Devices.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Consumer Security Device Manager to return the devices.
   * @summary Retrieves the devices registered for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesGetDevicesResponse>
   */
  getDevices(options?: Models.DevicesGetDevicesOptionalParams): Promise<Models.DevicesGetDevicesResponse>;
  /**
   * @param callback The callback
   */
  getDevices(callback: coreHttp.ServiceCallback<Models.Device[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getDevices(options: Models.DevicesGetDevicesOptionalParams, callback: coreHttp.ServiceCallback<Models.Device[]>): void;
  getDevices(options?: Models.DevicesGetDevicesOptionalParams | coreHttp.ServiceCallback<Models.Device[]>, callback?: coreHttp.ServiceCallback<Models.Device[]>): Promise<Models.DevicesGetDevicesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getDevicesOperationSpec,
      callback) as Promise<Models.DevicesGetDevicesResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to create/update a specific device based on the
   * information provided.
   * @summary Registers (replaces if the device already exists) a device for the user based on the
   * information provided.
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesRegisterDeviceResponse>
   */
  registerDevice(options?: Models.DevicesRegisterDeviceOptionalParams): Promise<Models.DevicesRegisterDeviceResponse>;
  /**
   * @param callback The callback
   */
  registerDevice(callback: coreHttp.ServiceCallback<Models.Device>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  registerDevice(options: Models.DevicesRegisterDeviceOptionalParams, callback: coreHttp.ServiceCallback<Models.Device>): void;
  registerDevice(options?: Models.DevicesRegisterDeviceOptionalParams | coreHttp.ServiceCallback<Models.Device>, callback?: coreHttp.ServiceCallback<Models.Device>): Promise<Models.DevicesRegisterDeviceResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      registerDeviceOperationSpec,
      callback) as Promise<Models.DevicesRegisterDeviceResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to return the devices summary.
   * @summary Retrieves the devices summary for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesGetDevicesSummaryResponse>
   */
  getDevicesSummary(options?: Models.DevicesGetDevicesSummaryOptionalParams): Promise<Models.DevicesGetDevicesSummaryResponse>;
  /**
   * @param callback The callback
   */
  getDevicesSummary(callback: coreHttp.ServiceCallback<Models.DevicesSummary>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getDevicesSummary(options: Models.DevicesGetDevicesSummaryOptionalParams, callback: coreHttp.ServiceCallback<Models.DevicesSummary>): void;
  getDevicesSummary(options?: Models.DevicesGetDevicesSummaryOptionalParams | coreHttp.ServiceCallback<Models.DevicesSummary>, callback?: coreHttp.ServiceCallback<Models.DevicesSummary>): Promise<Models.DevicesGetDevicesSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getDevicesSummaryOperationSpec,
      callback) as Promise<Models.DevicesGetDevicesSummaryResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to return the specific device by its deviceId.
   * @summary Retrieves the device registered for the current user by its deviceId.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesGetDeviceResponse>
   */
  getDevice(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.DevicesGetDeviceResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getDevice(deviceId: string, callback: coreHttp.ServiceCallback<Models.Device>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getDevice(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.Device>): void;
  getDevice(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.Device>, callback?: coreHttp.ServiceCallback<Models.Device>): Promise<Models.DevicesGetDeviceResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getDeviceOperationSpec,
      callback) as Promise<Models.DevicesGetDeviceResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to update a specific device based on the information
   * @summary Updates a device's info for the user based on the information provided.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesUpdateDeviceResponse>
   */
  updateDevice(deviceId: string, options?: Models.DevicesUpdateDeviceOptionalParams): Promise<Models.DevicesUpdateDeviceResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  updateDevice(deviceId: string, callback: coreHttp.ServiceCallback<Models.Device>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateDevice(deviceId: string, options: Models.DevicesUpdateDeviceOptionalParams, callback: coreHttp.ServiceCallback<Models.Device>): void;
  updateDevice(deviceId: string, options?: Models.DevicesUpdateDeviceOptionalParams | coreHttp.ServiceCallback<Models.Device>, callback?: coreHttp.ServiceCallback<Models.Device>): Promise<Models.DevicesUpdateDeviceResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      updateDeviceOperationSpec,
      callback) as Promise<Models.DevicesUpdateDeviceResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to remove (destroy=true) or sign out (destroy=false) a
   * specific device based on the deviceId
   * @summary Removes or signs out a device for the user based on the information provided.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteDevice(deviceId: string, options?: Models.DevicesDeleteDeviceOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  deleteDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteDevice(deviceId: string, options: Models.DevicesDeleteDeviceOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  deleteDevice(deviceId: string, options?: Models.DevicesDeleteDeviceOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      deleteDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Consumer Security Device Manager to return the device users for specific device by its
   * deviceId.
   * @summary Retrieves users associated with the device by its deviceId.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesGetDeviceUsersResponse>
   */
  getDeviceUsers(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.DevicesGetDeviceUsersResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getDeviceUsers(deviceId: string, callback: coreHttp.ServiceCallback<Models.AssociatedUser[]>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getDeviceUsers(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.AssociatedUser[]>): void;
  getDeviceUsers(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.AssociatedUser[]>, callback?: coreHttp.ServiceCallback<Models.AssociatedUser[]>): Promise<Models.DevicesGetDeviceUsersResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getDeviceUsersOperationSpec,
      callback) as Promise<Models.DevicesGetDeviceUsersResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to generate the device token by its deviceId.
   * @summary Generates the device token for the registered user by its deviceId.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.DevicesGenerateDeviceTokenResponse>
   */
  generateDeviceToken(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.DevicesGenerateDeviceTokenResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  generateDeviceToken(deviceId: string, callback: coreHttp.ServiceCallback<Models.DeviceToken>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  generateDeviceToken(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.DeviceToken>): void;
  generateDeviceToken(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.DeviceToken>, callback?: coreHttp.ServiceCallback<Models.DeviceToken>): Promise<Models.DevicesGenerateDeviceTokenResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      generateDeviceTokenOperationSpec,
      callback) as Promise<Models.DevicesGenerateDeviceTokenResponse>;
  }

  /**
   * Calls Consumer Security Device Manager to revoke the device token by its deviceId.
   * @summary Revokes the device token for the registered user by its deviceId.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  revokeDeviceToken(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  revokeDeviceToken(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  revokeDeviceToken(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  revokeDeviceToken(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      revokeDeviceTokenOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getDevicesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Devices",
  queryParameters: [
    Parameters.includeDeletedDevices0
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Device"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Devices",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeviceCreate
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.Device
    },
    201: {
      bodyMapper: Mappers.Device
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getDevicesSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Devices/summary",
  queryParameters: [
    Parameters.excludeDevice,
    Parameters.sortBy,
    Parameters.sortOrder,
    Parameters.includeDeletedDevices1,
    Parameters.includeFamily0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.DevicesSummary
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Devices/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.Device
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Devices/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeviceUpdate
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.Device
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/Devices/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  queryParameters: [
    Parameters.destroy
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getDeviceUsersOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Devices/{deviceId}/users",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssociatedUser"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const generateDeviceTokenOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Devices/{deviceId}/token",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.DeviceToken
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const revokeDeviceTokenOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Devices/{deviceId}/token",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
